import { RINK_RELATED } from '../constants';

import type { Flow } from '../constants';

type TypeIsRinkRelated = (flow: Flow) => boolean;

export const isRinkRelated: TypeIsRinkRelated = (flow) =>
  RINK_RELATED.includes(flow);
